import request from '@/utils/request'

// 获取主单信息
export function selectPriceCompInfoById(obj) {
  return request({
    url: '/api/srm-slcm/pmPriceCompInfo/selectPriceCompInfoById',
    method: 'post',
    data: obj
  })
}

// 获取配额调整审批主表信息
export function selectSuppInfoByPcInfoId(query) {
  return request({
    url: '/api/srm-slcm/pmPriceCompSupp/selectSuppInfoByPcInfoId',
    method: 'get',
    params: query
  })
}

// 获取配额调整审批主表信息
export function selectAwardInfoByPcInfoId(query) {
  return request({
    url: '/api/srm-slcm/pmPriceCompQuoteInfo/selectAwardInfoByPcInfoId',
    method: 'get',
    params: query
  })
}

// 获取配额调整审批主表信息
export function searchPriceCompSupp(query) {
  return request({
    url: '/api/srm-slcm/pmPriceCompSupp/searchPriceCompSupp',
    method: 'get',
    params: query
  })
}

// 获取标的阶梯价格
export function getQuoteInfoByPcInfoId(query) {
  return request({
    url: '/pi/srm-slcm/pmPriceCompQuoteInfo/getQuoteInfoByPcInfoId',
    method: 'get',
    params: query
  })
}
